import request from '@/utils/request'
import Vue from 'vue'

// 登录方法
export function login(phone,smscode) {
    const data = {
        phone,
        smscode
    }
    return request({
        url: Vue.prototype.$api.login.index,
        headers: {
            isToken: false,
        },
        method: 'post',
        data: data,
    })
}

// 注册方法
export function register(data) {
    return request({
        url: Vue.prototype.$api.login.register,
        headers: {
            isToken: false,
        },
        method: 'post',
        data: data,
    })
}

// 获取用户详细信息
export function getInfo() {
    return request({
        url: Vue.prototype.$api.login.userinfo,
        method: 'post',
    })
}

// 退出方法
export function logout() {
    return request({
        url: Vue.prototype.$api.login.logout,
        method: 'post',
    })
}

// 更新个人信息
export function update(data) {
    return request({
        url: Vue.prototype.$api.login.update,
        method: 'post',
        data,
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: Vue.prototype.$api.login.getCaptcha,
        method: 'get',
        responseType: 'arraybuffer',
    })
}

// 获取短信验证码
export function getsmsCode(data) {
    return request({
        url: Vue.prototype.$api.login.sendsms,
        method: 'post',
        data,
    })
}

// 获取微信二维码登录地址
export function getWxCode(params) {
    console.log('getWxCode', params)
    return request({
        url: Vue.prototype.$api.login.createQrcode,
        method: 'get',
        params,
    })
}

// 后台管理员绑定微信号

export function bindWx(params) {
    return request({
        url: Vue.prototype.$api.login.bindWechat,
        method: 'get',
        params,
    })
}

export function unBindWechat(params) {
    return request({
        url: Vue.prototype.$api.login.unBindWechat,
        method: 'get',
        params,
    })
}

// 获取token
export function getToken(params) {
    return request({
        url: Vue.prototype.$api.login.getLoginToken,
        method: 'get',
        params,
    })
}

// 获取用户信息

export function getUserInfo(params) {
    return request({
        url: Vue.prototype.$api.login.getBindUserinfo,
        method: 'get',
        params,
    })
}


// 扫码登录回调


export function mockcodeNotify(params) {
    return request({
        url: Vue.prototype.$api.login.mockcodeNotify,
        method: 'get',
        params,
    })
}

//  后台绑定回调


export function mockbindNotify(params) {
    return request({
        url: Vue.prototype.$api.login.mockbindNotify,
        method: 'get',
        params,
    })
}
